import React from 'react';
import StatusWidget from '../../DataTables/DataTableComponents/StatusWidget';

export default function PropertyNotificationsCard() {
	return (
		<div className="PropertyNotificationsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">
						Notifications
					</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<span className="float-right hover:underline">Edit</span>
						<div className="grid md:grid-cols-12">
							<div className="md:col-span-6">
								<div className="font-semibold">Type</div>
								<div>
									<span className="my-1 mr-3">Report Revenue Reminder</span>
									<StatusWidget status="Active" />
								</div>
								<div className="font-semibold mt-4">Frequency</div>
								<span className="mr-2 block">Daily</span>
							</div>
							<div className="md:col-span-6 mt-4 md:mt-0">
								<div className="font-semibold">Delivery Method</div>
								<span className="mr-2 block">Email & Text</span>
								<div className="font-semibold mt-4">Sent To</div>
								<span className="mr-2 block">
									mhoelzel23@gmail.com & 303-847-7964
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
